import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const ContainerCard = styled.div`
    min-height: 108px;
    max-width: 430px;
    background-color: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.borderGreyLink};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
`;

export const AlignCard = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    min-width: 100%;
    height: 100%;
    min-height: 108px;
`;

export const TextAlign = styled.div`
    flex-direction: column;
    flex: 1;
    padding: 15px 0;
`;

export const Icone = styled.div`
    margin: 0 24px 0 24px;
    color: ${(props) => props.theme.orangeLink};
`;

export const Title = styled.div`   
    color: ${(props) => props.theme.orangeLink};
    font-size: ${theme.font.size18};
    font-weight: bold;
    width: 100%;
`;

export const SubTitle = styled.div`   
    font-size: ${theme.font.size14}; 
    color: ${(props) => props.theme.greyLink};
    width: 100%;
`;

export const ArrowRight = styled.div`
    margin: 0 24px;
`;
